import * as api from '../../constants/api';
import callApi from '../http';

const getSupportNumber = async (body) => await callApi(api.SUPPORT_NUMBER, body);

const getReasonSupport = async (body) => await callApi(api.REASON_SUPPORT_LIST, body);

const supportRequest = async (body) => await callApi(api.SUPPORT_REQUEST, body);

const operatorProfile = async (params) => await callApi(api.OPERATOR_PROFILE, params);

const applicationConfig = async (body) => await callApi(api.APPLICATION_CONFIG, body);

const operatorUpdateOnline = async (params) =>
  await callApi(api.OPERATOR_UPDATE_ONLINE, params);

const operatorUpdatePassword = async (params) =>
  await callApi(api.OPERATOR_UPDATE_PASSWORD, params);

export {
  supportRequest,
  operatorProfile,
  getSupportNumber,
  applicationConfig,
  operatorUpdateOnline,
  operatorUpdatePassword,
  getReasonSupport,
};
